// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"style_mainContent__2RIcz","newButton":"style_newButton__2QtC4"};